import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class VideoService {

  public pauseOrPlayVideo = new Subject<string>();
  public pauseOrPlayVideo$: Observable<string> = this.pauseOrPlayVideo.asObservable();

  public openVideoSource = new Subject<string>();
  public openVideoSource$: Observable<string> = this.openVideoSource.asObservable();



  public pausePlayVideo() {
      this.pauseOrPlayVideo.next();
  }

  public openVideoPalyer(videoUrl: any) {
    this.openVideoSource.next(videoUrl);
  }

}
